import { Form, Input, Checkbox, FormProps, Select, FormInstance, Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";

import { ChildForm, FieldDB, TabForm } from 'interfaces/schemaDB';
import { CrudFilters, CrudFilter, ConditionalFilter, LogicalFilter } from '@refinedev/core/dist/interfaces';
import Cw8Field from './Cw8Field';

// import {  } from '@refinedev/core/dist/interfaces';
// import { CrudFilter } from '@refinedev/core';
import { FormMode, ProviderTypes } from '../../../src/interfaces/interfaces';
// import moment from "moment-timezone";
import moment from 'moment'
import { config } from "config";
import Cw8List from "./Cw8List";
import { useRef } from "react";


interface Cw8FieldProps{
    fieldList: FieldDB[]
    formMode : FormMode
    filterList?: CrudFilters | undefined
    record?: unknown
    resourceName : string
    form : FormInstance
}

const Cw8FieldsForm = ({fieldList, filterList, record, formMode, resourceName, form}: Cw8FieldProps ) => {
    const editorRefs = useRef<Record<string, any>>({}); 
    return(
        <>
        {
                fieldList.map( (field, idx) =>(
                    <Cw8Field
                        key = {idx}
                        field = {field}
                        filterList = {filterList}
                        record = {record}
                        formMode = {formMode}
                        resourceName = {resourceName}
                        form = {form}
                        editorRefs={editorRefs}
                    ></Cw8Field>
                ))
        }
        </>
    )

}

export default Cw8FieldsForm